// extracted by mini-css-extract-plugin
export default {"element-loading":"ButtonsLoading_element-loading__HcXGL"};